"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Highlighter } from "@/components/magicui/highlighter";
import { MAIN_COLOR } from "@/utils/constants";

const DownloadResumeBtn = ({
  resume,
}: {
  resume: { ar?: string; en?: string };
}) => {
  const t = useTranslations();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button>{t("Download CV")}</Button>
      </DialogTrigger>
      <DialogContent className="w-lg rounded-[5px] p-10">
        <DialogTitle className="hidden"></DialogTitle>
        <p>
          {t(" You can download my resume in")}{" "}
          <Highlighter color={MAIN_COLOR} action="underline">
            <span className="font-bold p-1">{t("Arabic")}</span>
          </Highlighter>{" "}
          {t("or")}{" "}
          <Highlighter color={MAIN_COLOR} action="underline">
            <span className="font-bold p-1">{t("English")}</span>
          </Highlighter>
        </p>
        <div className="flex justify-center mt-4 items-center gap-4">
          <a
            href={resume?.ar}
            target="_blank"
            download
            rel="noopener noreferrer"
          >
            <Button>{t("Arabic")}</Button>
          </a>
          <a
            href={resume?.en}
            target="_blank"
            download
            rel="noopener noreferrer"
          >
            <Button>{t("English")}</Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadResumeBtn;
